module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2",
    attrs: {
      "id": "int"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('em', [_vm._v("Introduction")]), _c('br'), _vm._v("Money for Science")]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("I"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("T IS A TRUTH UNIVERSALLY ACKNOWLEDGED")]), _vm._v(" that a scientist in possession of experience and expertise must be in search of funding. Today supporting someone to do science is routine. Scientists abound in universities, private foundations, government agencies, and corporate research and development laboratories. Science is a job, and scientists are professionals. For most of the nineteenth century, neither was true. Science had few established sources of support, and the descriptive noun "), _c('em', [_vm._v("scientist,")]), _vm._v(" a term coined in Britain in the 1830s, was rarely used in America until late in the century. Nineteenth-century men of science were becoming professionals, and key to that process was money—money to live on and money to do science. How American men of science made a living "), _c('em', [_vm._v("by doing")]), _vm._v(" science is a crucial historical question."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn1"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn1a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One place to start looking for an answer is the geological and natural history surveys of the first third of the nineteenth century. Organized at both the state and federal levels, surveys were a form of government patronage providing salaried positions to a large number of geologists, chemists, botanists, zoologists, and mineralogists. During the 1830s and 1840s, surveys were the training grounds, so to speak, for the first generation of American men of science. (Women at this time were consciously excluded from surveys and largely from science in general.)"), _c('sup', [_c('a', {
    attrs: {
      "id": "intn2"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn2a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" Surveys stimulated the growth of scientific disciplines as well as the development of a national scientific community."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn3"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn3a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" They also provided a measure of legitimation by putting science at the service of government and the public. Surveys were thus seeds around which a form of professional American science began to crystallize."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn4"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn4a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The process, however, was halting, largely because surveys were short-lived. Once completed, surveyors faced the daunting task of finding further employment as "), _c('em', [_vm._v("men of science.")]), _vm._v(" And there were not many options. In this regard, the situation was different from that in Britain, where there was an array of opportunities for getting paid to do science, including writing, editing, reviewing, instrument making, and public lecturing."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn5"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn5a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" That kind of scientific work was not available in America because there was not such a well-developed market for the "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("display of knowledge. Nor was there a large class of wealthy patrons. As Alexander Dallas Bache, director of the U.S. Coast Survey, put it, “we have no rich aristocracy or extended middle ranks to be enlisted in the cause [of science].”"), _c('sup', [_c('a', {
    attrs: {
      "id": "intn6"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn6a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" Bache’s comments on class point to another distinction. In Britain and continental Europe, men of science were often men of means—in a word, gentlemen."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn7"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn7a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" In America, men of science came from modest backgrounds; they were the sons of ministers, lawyers, physicians, teachers, and small farmers."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn8"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn8a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" If Americans were going to do science, they were going to have to work at it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Making money doing science required initiative, luck, and no small degree of self-promotion, besides the requisite experience and expertise. In other words, nineteenth-century American men of science had to be entrepreneurs. Accordingly, many became active lobbyists for the creation of, or appointments to, new state and federal surveys. Some sought teaching positions, although these did not provide much time, money, or encouragement to do research. Still others opted for the path chosen by William W. Mather and James Hall. In 1838 Mather and Hall were geologists working on the New York State Geological and Natural History Survey. Because they knew the survey would come to an end, they decided to set up a business doing geology, and they issued an advertisement of their professional services.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_c('strong', [_vm._v("Minerals, Mines, Ores, &c. Examined")])]), _vm._v(" "), _c('p', {
    staticClass: "blockquotef"
  }, [_vm._v("Messrs. W. W. Mather, and James Hall, Geologists, have established an office for the analysis and assay of minerals and ores; for the examination of mines, mining districts, mineral beds, quarries and quarry stones; for communicating information upon the best methods of smelting and working ores and minerals to bring them to a marketable state; and for imparting all the various knowledge which is a necessary preliminary to the successful prosecution of mining enterprises. So many mining operations are undertaken through mistaken views of their probable productiveness, and even of the nature of the mineral ore, that it is deemed necessary for the public interest that an office similar to that mentioned should be established. This professional knowledge is as important to the community, to prevent the undertaking of mining and metallurgic operations where they would be unproductive, as to guide and direct enterprise to the most economical and profitable methods of working mines and preparing their marketable products.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotef"
  }, [_vm._v("Messrs. Mather and Hall have had experience of several years in the different branches of their profession, and now solicit the patronage of the public. The office will impart information, not only upon the subjects above mentioned, but upon the applications of all mineral substances to the various useful purposes of life.")]), _vm._v(" "), _c('p', {
    staticClass: "blockquotef"
  }, [_c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _vm._v("Letters, post-paid, addressed to Messrs. Mather & Hall, Mining Engineers, corner of South-Market and Hudson sts., Albany, soliciting information, and enclosing a fee of five dollars, will be promptly attended to. Should it be necessary to examine the locality of the mineral or ore, or make an assay or chemical analysis, or make drawings, and give descriptions of machinery, furnaces, &c., &c. an additional fee will be charged, varying in amount according to circumstances.")]), _vm._v(" "), _c('p', {
    staticClass: "attribution"
  }, [_vm._v("January 1, 1838"), _c('sup', [_c('a', {
    attrs: {
      "id": "intn9"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn9a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraspaceabove"
  }, [_vm._v("Setting up an office for the business of science went by another name, "), _c('em', [_vm._v("consulting,"), _c('sup', [_c('a', {
    attrs: {
      "id": "intn10"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn10a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" and it would prove to be the most profitable and popular avenue of scientific entrepreneurship in nineteenth-century America."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn11"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn11a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The development of consulting marks a historically significant, yet hitherto unexamined, broadening of the patronage for science."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn12"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn12a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" Patronage, as scholars have shown, is critical to the pursuit of science."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn13"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn13a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" It involves complex exchanges of credit (both social and scientific) and of capital (cultural and, of course, financial). In moving from government employment to “the patronage of the public,” Mather and Hall were among the first men of science to try to capitalize on their survey experience and scientific expertise. Many others would follow, including geologists like Charles Thomas Jackson, Abraham Gesner, Henry Darwin Rogers, J. Peter Lesley, Josiah Dwight Whitney, and John Strong Newberry; chemists such as Benjamin Silliman (father and son), Augustus A. Hayes, and Thomas Antisell; and a handful of renowned naturalists, for example, John Torrey and Joseph Leidy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Geologists, though, were the most prominent and prosperous consultants, and the centrality of their science highlights some distinct features of the American context. For, unlike France and Germany, where state-trained engineers provided mining expertise, or Britain, where land surveyors, canal builders, and coal prospectors proffered such advice (gentlemanly geologists, by virtue of class and custom, had little to do with British mining),"), _c('sup', [_c('a', {
    attrs: {
      "id": "intn14"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn14a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" in the United States the best-trained and most numerous experts available were geologists. In fact, the proportion of geologists to men of science was greater in America than in any other country."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn15"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn15a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" By contrast, the physical sciences were not well developed in America before the late nineteenth century. And noticeably absent from the ranks of consultants were astronomers, physicists, and mathematicians. Scholars, however, have focused closely on the small coterie in the physical sciences and, as a result, have failed to recognize the profound impact that consulting had on American science and society."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn16"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn16a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As it developed in the three decades before the Civil War, consulting came to form a central part of the practice and identity of American men of science. That Mather and Hall felt the need to advertise spoke to the novelty of this type "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }), _vm._v("of professional science in the 1830s. Within a decade, however, no such publicity was needed, and by the 1850s consulting was commonplace. Numerous men of science offered various services and information, especially regarding the land and its minerals, to any and all members of the interested public. Broadly defined, consulting is what all active men of science did, regardless of whether they offered their experience and expertise to enterprising individuals, private companies, or state governments. Whatever the employment, men of science had the chance to contribute actively and directly to the common weal and wealth. Such civic engagement reflected well on consultants’ entrepreneurship and reinforced the widely held assumption that science was useful and therefore should be used. In theory, then, consulting was another means by which science promoted material improvements and general enlightenment."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn17"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn17a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In practice, consultants solicited the patronage of a particular segment of the public—capitalists. In midcentury America, the ideal capitalist was a gentleman, well informed (if not also well educated), well connected (if not also wellbred), and well-off (if not downright rich). Model capitalists had money to invest and plans to build, but the projects on which capitalists might consult men of science were not so large as railroads or canals, the kinds of internal improvements requiring large amounts of government funding, but rather on the scale of a mine or manufactory, investments needing other capitalists or, after 1850, funds raised by joint-stock companies."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn18"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn18a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" Capitalists and their companies engaged consultants for more than mere promotion or puff. Consultants provided the science needed to purchase lands, dig mines, design and build equipment, improve manufacturing processes, and market new products. On occasion, consultants were called upon to testify in court cases involving patent rights. By midcentury, patents were being taken out for processes and products that involved demonstrable degrees of scientific research. Expert witnessing was courtroom consulting by another name and, hence, another profitable branch of scientific entrepreneurship."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn19"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn19a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Whatever their specific responsibilities, consultants proved to be major proponents of invention and innovation. They were agents of midcentury technological change and economic growth. Admittedly, change and growth are roomy concepts that can be applied to just about any time or place. The decades during which consulting developed have been described by various labels—Industrial Revolution, Transportation Revolution, Market Revolution, Age of Enterprise—each purporting to capture a fundamental transformation in the American economy and society. In none of these familiar interpretations do men of science figure."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn20"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn20a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" Nor for that matter do such great transformations seem to have much of an impact on American science."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn21"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn21a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Nineteenth-century science and industry seem to be two trains headed in the same direction but running "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("on separate tracks. By most scholarly accounts, convergence occurred at some distant point late in the century with the emergence of professional engineering and science-based industry, the hallmarks of the so-called Second Industrial Revolution. The popularity of consulting, however, points to contacts that occurred earlier than and differently from previously thought.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The development of consulting defines a crucial phase in the relations among science, technology, and industry, relations that have troubled scholars for quite some time."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn22"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn22a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" There remains much debate, for instance, about the contributions of science to the British Industrial Revolution of the late eighteenth century, although new studies have highlighted the busy activities of natural philosophers in projects for wealthy landowners intent on improvement."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn23"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn23a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" American consultants had similar interests in improvements and progress, but unlike their eighteenth-century English predecessors, they undertook more numerous, widespread, and impersonal engagements. By design and definition, consulting was a short-term, advisory activity and, in this way, was also different from the kind of industry-based science that appeared in the laboratories of chemical and electrical firms toward the end of the nineteenth century."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn24"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn24a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Consultants worked alone or in partnerships, not in corporate confines with their concomitant physical plants and brand-name identities. Consultants were not permanent employees or parts of product development; they were independent, professional men of science.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“By professional I meant geological,” explained Lesley, “as geology is my profession.”"), _c('sup', [_c('a', {
    attrs: {
      "id": "intn25"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn25a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" If geology were the science with the most to offer American mid-century industry, it only stood to reason that geology had the most to gain. Private engagements provided geologists with access to unexplored lands, un-examined minerals, and unexplained phenomena. In consulting lay the routine of normal fieldwork as well as the new materials for research. Private engagements thus had much in common with government surveys. But consulting had a social location different from a survey, or a university, or a government bureau. It was a professional practice pointing toward the union of science and capitalism.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To assert that consulting emerged in concert with the growth of nineteenth-century industry, or with a distinct form of professional science, or with the development of American geology, does not, however, fully address the question of how the practice wove together these strong historical cords. To do so, this study tracks the development of American coal and petroleum, material resources that were simultaneously subjects of immense scientific and industrial interest and hence the objects of commercial engagements for enterprising men of science. Consulting on coal and petroleum epitomized practical science, and to nineteenth-century Americans, practical meant both “scientific” and “economical.” "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _vm._v("It did not mean untheoretical, as some scholars have asserted."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn26"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn26a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" In studying coal and petroleum, American geologists, chemists, and naturalists were anything but indifferent to basic research "), _c('em', [_vm._v("or")]), _vm._v(" to the needs of industry."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn27"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn27a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This peculiar combination of science, mining, and consulting led to the American specialties of coal and petroleum geology. In the early and mid-nineteenth century, coal was the most heavily researched subject (in both private and public surveys) because it was unquestionably the most valuable mineral."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn28"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn28a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" And not just because it was needed to fuel steam engines, to light buildings, or to heat homes. Coal was key to explaining the earth’s structure and to delineating the earth’s history—specifically, to how rocks were laid down in oceans or thrown up into mountains and to how rocks were identified and ordered from oldest to youngest. Coal was also key to understanding the transformations that occurred when plants and animals died. Finally, the complex geometry of coal fields forced changes in the methods of doing geological field-work; the contour map and topographic surveying became the essential elements of a new specialty that Americans named structural geology. In similar fashion, Americans created petroleum geology, a scientific specialty combining chemical research into petroleum’s organic constituents with field studies of the structural conditions required for its accumulation."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn29"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn29a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Petroleum geology relied on the new technologies of well boring and well records to push the contours of structural geology deep underground. In the cases of coal and petroleum, consulting flourished because the interests of science and industry were complementary.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To illustrate the extent of this complementarity and to help in navigating the shifting scientific landscape, this study follows the extraordinary career of the Albert mineral. Discovered in Albert County, New Brunswick, in 1849, this volatile and valuable substance became famous as the source of a twenty-five-year scientific, legal, and commercial controversy over whether it was coal-like or petroleum-like. Men of science consulted for companies wanting to mine and process the mineral, and they served as expert witnesses in celebrated court cases between capitalists wanting to own and patent it. Substantively and symbolically, the Albert mineral grounds the theoretical arguments about scientific entrepreneurship and the relations among science, technology, and industry in midcentury America. In a sense, the mineral is treated as a character, not unlike the men of science themselves, in the development of American consulting.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The principal use for the Albert mineral was lighting. While the history of electrical lighting is well known, that of coal gas and coal oil is not. Coal-based lighting required its own scientific, technological, legal, and commercial system—or, more precisely, systems, for coal gas and coal oil, although closely related, evolved differently."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn30"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn30a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" This study pays particular attention to coal oil, or "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _vm._v("kerosene as it was often called. Kerosene was the first manufactured mineral oil. As it became increasingly popular and profitable during the late 1850s, kerosene became the subject of a series of important public and legal debates about the meaning of invention and innovation. As products of “technological science”—a new concept of the midcentury—mineral oils raised challenging questions about the role that science "), _c('em', [_vm._v("could")]), _vm._v(" and "), _c('em', [_vm._v("should")]), _vm._v(" play in industry."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn31"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn31a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Part of that debate concerned the dark side to the coin of consulting. Men of science, along with men of business and politics, worried about what would happen if, and when, the interests of science and industry were not complementary. The danger with fees-for-expertise was that it smacked of interest. Money might uproot the good of science and the goodwill of the public. The excesses of Gilded Age capitalism, particularly in the oil industry, brought into bold relief the ethical and moral troubles intrinsic to this form of professional science. Consulting was at the heart of one of the most troubling scandals in nineteenth-century American science. The setting was the National Academy of Sciences, and the subject was California petroleum. The controversy pitted Josiah Dwight Whitney, a former consulting geologist who in 1860 became the director of the California Geological Survey, against Benjamin Silliman Jr., the consulting chemist for several California oil companies. On the surface, theirs was a disagreement over the origin and occurrence of petroleum, a scientific dispute that went back to questions about the classification of the Albert mineral. At a deeper level, the controversy was about where American science should be practiced (on government surveys or corporate assignments), who should do it (public surveyors or private consultants), and who should pay for it (the people or the companies). All these unresolved issues were brought to the fore when Whitney accused Silliman of swindling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scientist or swindler? It is a perfect endpoint for a study that traverses North America from early nineteenth-century New Brunswick to Gilded Age California. In following the careers of the most influential consultants, from their work on government surveys to their engagements for mining and manufacturing companies, the story moves within, as well as across, the contours of scholarship in the history of science and technology, law and ethics, business and economic history, and environmental and science studies. Coal and oil serve as stepping-stones between the diverse places, personalities, scientific theories and methods, and technologies and industries. Perforce as much as per design, it is a complex tale about the imperfect fit between the human attempts to order the world and the intransigent materials they confront along the way."), _c('sup', [_c('a', {
    attrs: {
      "id": "intn32"
    }
  }), _c('span', {
    staticClass: "nounder",
    attrs: {
      "href": "#/xhtml/ch12_notes#intn32a",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" The extended efforts to classify coal and oil, to explain their origin and occurrence, and to explore and exploit their deposits reflected larger problems of social definition and intellectual categorization: what are the differences, if any, between "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _vm._v("theory and practice, technology and science, discovery and invention, and ethical and unethical behavior? Even the coolest-headed consultants realized that commercial engagements could lead to moral entanglements. Mixing money and science was (and still is) a volatile concoction. The search for truth and the pursuit of the almighty dollar were not (and are not) always and everywhere compatible. Still, scientists have to work. And if they work for money, is the science they do less trustworthy and true?")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-582ea3a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch00_fm10_int.vue
// module id = 87
// module chunks = 0